import React from 'react'
import { Navigate } from 'react-router-dom'
import { isAuth } from '../Utils/HelperFuntions'

const PrivateRoute = ({ children }) => {

   const auth = isAuth()

   return auth ? children : <Navigate to='/log-in' />
}

export default PrivateRoute